<template>
  <div>
    <div class="backed" v-if="formData.outlayStatus == 2 || formData.outlayStatus == 3">
      <img src="/static/err-icon.png" alt="" />
      <span v-if="formData.outlayStatus == 2" class="back-title">退回原因：</span>
      <span v-if="formData.outlayStatus == 3" class="back-title">放弃原因：</span>
      <span class="back-msg">{{ formData.apprOpinion }}</span>
    </div>
    <dialogPanel>

      <ChapterHead>
        <span>费用编号：{{formData.outlayId}}</span>
        <span slot="extra">
          <!-- <el-button :loading="loading" type="primary" v-if="!readOnly" icon="el-icon-s-release" size="mini" @click="saveData">暂存</el-button>
          <el-button :loading="loading" type="primary" v-if="!readOnly" icon="el-icon-success" size="mini" @click="submitData">提交</el-button>
          <el-button :loading="loading" type="primary" v-if="!disabled" icon="el-icon-close" size="mini" @click="close">关闭</el-button> -->
          <img src="/static/status-icon.png" style="width: 15px;height: 15px;margin-right: 6px;vertical-align: middle;" alt="">
          <span style="vertical-align: middle;">{{formData.outlayStatusName}}</span>
        </span>
      </ChapterHead>
      <el-form ref="formData" :loading="loading" :model="formData" :rules="formRules" :inline="true" label-width="180">
        <el-row>
          <el-col :span="6">
            <el-form-item label="救助医院" prop="hospitalName">
              <el-input type="text" disabled v-model="formData.hospitalName" size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="病种" prop="beforeDiseasesIdList">
              <el-input :value="formData.afterDiseasesName || '-'" disabled size="small" />
              <!-- <DiseaseCascader
                v-else
                v-model="formData.beforeDiseasesIdList"
                :hospitalId="formData.hospitalId"
                :multiple="true"
                :disabled="true"
              ></DiseaseCascader> -->
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="救助限额" prop="specialQuota">
              <el-input type="text" :value="parseFloat(formData.specialQuota || 0).toFixed(2)" :disabled="true" size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="检查时间" prop="checkTime">
              <el-date-picker
                v-model="formData.checkTime"
                align="right"
                size="small"
                type="date"
                placeholder="选择时间"
                :disabled="readOnly"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发票张数" prop="billCount">
              <NumberInput v-model="formData.billCount" :disabled="readOnly"></NumberInput>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="检查费用" prop="checkOutlay">
              <el-input v-if="readOnly" :value="parseFloat(formData.checkOutlay || 0).toFixed(2)" disabled />
              <MoneyInput v-else v-model="formData.checkOutlay" :disabled="readOnly"></MoneyInput>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="救助费用" prop="helpAmount">
              <el-input v-if="readOnly" :value="parseFloat(formData.helpAmount || 0).toFixed(2)" disabled />
              <MoneyInput v-else v-model="formData.helpAmount" :disabled="readOnly"></MoneyInput>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" v-model="formData.remark" :rows="3" :disabled="readOnly"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="检查状态" prop="checkStatus">
              <DictionarySelect v-model="formData.checkStatus" tableCode="CHECK_STATE" :lazy="true" :disabled="readOnly"></DictionarySelect>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="发票附件" prop="attachList">
              <FileUpload v-model="formData.attachList" :disabled="readOnly"></FileUpload>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </dialogPanel>
    <el-collapse v-if="readOnly" :value="['1', '2', '3']" >
      <MyCollapse v-if="readOnly" title="辅助信息"  iconPath="/static/de-zmr.png"  name="2">
        <OutlayOtherInfo v-if="readOnly" :formData="formData"></OutlayOtherInfo>
      </MyCollapse>
    </el-collapse>
  </div>
</template>

<script>
import { getOutlayDataById, saveCheckOutlay, submitCheckOutlay } from "@/util/api.js";
import DictionarySelect from "@/components/business/DictionarySelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import FileUpload from "@/components/business/FileUpload";
import MoneyInput from "@/components/business/MoneyInput";
import NumberInput from "@/components/business/NumberInput";
import ChapterHead from "@/components/business/ChapterHead";
import dialogPanel from "@/components/business/dialogPanel";
import MyCollapse from "@/components/business/MyCollapse";
import OutlayOtherInfo from '../view/OutlayOtherInfo'

export default {
  components: {
    ChapterHead,
    DictionarySelect,
    DiseaseCascader,
    FileUpload,
    MoneyInput,
    NumberInput,
    dialogPanel,
    MyCollapse,
    OutlayOtherInfo
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    recordId: {
      type: String
    }
  },
  data() {
    const _this = this;
    return {
      disabled: false,
      loading: false,
      readOnly: false,
      formData: {},
      formRules: {
        checkTime: [{ required: true, message: '请选择检查时间', trigger: 'blur' }],
        billCount: [{ required: true, message: '请输入发票张数', trigger: 'blur' }],
        checkOutlay: [{ required: true, message: '请输入检查费用', trigger: 'blur' }],
        helpAmount: [
          { required: true, message: '请输入救助费用', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (parseFloat(value || 0) > parseFloat(_this.formData.specialQuota || 0)) {
              callback('救助费用不能超过救助限额');
            // } else if (_this.formData.checkOutlay && parseFloat(value || 0) > parseFloat(_this.formData.checkOutlay)) {
            //   callback('救助费用不能超过检查费用')
            } else {
              callback();
            }
          }, trigger: 'blur'}
        ],
        checkStatus: [{ required: true, message: '请选择检查状态', trigger: 'change' }],
      },
      helpRequestData: {}
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.recordId) {
        this.loading = true;
        getOutlayDataById(this.recordId).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            this.formData = res.responseData;
            if (this.formData.beforeDiseasesList && this.formData.beforeDiseasesList.length > 0) {
              this.formData.beforeDiseasesIdList = this.formData.beforeDiseasesList.map(dis => {
                return dis.diseasesId;
              });
            }
            this.$emit('load', this.formData);
            this.readOnly = this.disabled || (this.formData.isSend == 1 ? true : [0, 1, 2].indexOf(this.formData.outlayStatus) < 0);
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    saveData () {
      this.loading = true;
      this.$emit('beforeSave');
      saveCheckOutlay(this.formData).then(res => {
        this.loading = false;
        this.$emit('saveComplete');
        if (res.msgCode == 200) {
          this.$message.success('暂存成功！');
          this.close();
          this.$emit('success', this.formData);
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submitData () {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$emit('beforeSave');
          submitCheckOutlay(this.formData).then(res => {
            this.loading = false;
            this.$emit('saveComplete');
            if (res.msgCode == 200) {
              this.$message.success('提交成功！');
              this.close();
              this.$emit('success', this.formData);
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$emit('saveComplete');
        }
      });
    },
    close () {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/common/form.scss';
@import 'src/common/dialog.scss';
</style>


// WEBPACK FOOTER //
// src/pages/outlay/check/CheckOutlayDetail.vue